import React from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

import TravelerInformationBox from "components/Checkout/TravelerInformation/TravelerInformationBox";
import { travelerInformationSelector } from "redux/travelerInformation";
import { contactInformationSelector } from "redux/contactInformation";
import { useTranslations } from "hooks/useTranslations";

export default function TravelerInformationSummary() {
  const { translations } = useTranslations();
  const getIndexedTravelerTitle = (index: number) => {
    return translations.contactInformation.traveler + " " + (index + 1);
  };
  const contactSlice = useSelector(contactInformationSelector);
  const travelerSlice = useSelector(travelerInformationSelector);
  const travelers = travelerSlice.travelers;

  return (
    <Box
      sx={{
        width: { xs: 1, md: 400, lg: 300 },
        borderLeft: "1px solid",
        borderLeftColor: "grey.300",
      }}
    >
      <TravelerInformationBox
        title={translations.contactInformation.contactPerson}
        contactPerson={contactSlice}
      />

      {travelers.map((traveler, index) => {
        return (
          <TravelerInformationBox
            key={index}
            title={getIndexedTravelerTitle(index)}
            traveler={traveler}
            index={index}
          />
        );
      })}
    </Box>
  );
}
